import URI from 'urijs'
import { config } from '@/plugins/env.config'
import Vue from 'vue'

async function getSponsors(providerSlug, attemptNumber = 1){
  const getSponsorsURI = new URI(config.apiBaseUrl)
  getSponsorsURI.segment('providers')
  getSponsorsURI.segment('v1')
  getSponsorsURI.segment('providers')
  getSponsorsURI.segment(providerSlug)
  getSponsorsURI.segment('sponsors')
  
  try{
    return await Vue.prototype.$http.get(getSponsorsURI.toString())
  }catch(error){
    const maxAttempts = config.getTokenMaxAttempts
    const attemptDelayInSeconds = config.getTokenAttemptDelayInSeconds

    const response = error.response ? error.response : error
    const status = response.status ? response.status : error.status

    if (status === 500 && attemptNumber < maxAttempts) {
      await new Promise(resolve => setTimeout(resolve, attemptDelayInSeconds * 1000))
      return getSponsors(providerSlug, attemptNumber + 1)
    }

    throw error
  }
}

async function getSponsorProviders({sponsorSlug, searchValue}){
  const getSponsorProvidersURI = new URI(config.apiBaseUrl)
  getSponsorProvidersURI.segment('providers')
  getSponsorProvidersURI.segment('v1')
  getSponsorProvidersURI.segment('sponsors')
  getSponsorProvidersURI.segment(sponsorSlug)
  getSponsorProvidersURI.segment('providers')
  getSponsorProvidersURI.addQuery('query', searchValue)

  try{
    const response = await Vue.prototype.$http.get(getSponsorProvidersURI.toString())
    if(response.status === 202){
      const location = response.headers.location
      
      if(location){
        return await pollMonitor(location)
      }
    }
  }catch(error){
    const response = error.response
    throw response.data
  }
}

async function pollMonitor(location, attemptNumber = 1){
  const pollMonitorURI = new URI(location)
  try{
    const response = await Vue.prototype.$http.get(pollMonitorURI.toString())

    if(response.data.status === 'IN_PROGRESS'){
      const attemptDelayInSeconds = config.getTokenAttemptDelayInSeconds
      await new Promise(resolve => setTimeout(resolve, attemptDelayInSeconds * 2000))
      return pollMonitor(location)
    }

    return response
  }catch(error){
    const maxAttempts = config.getTokenMaxAttempts
    const attemptDelayInSeconds = config.getTokenAttemptDelayInSeconds

    const response = error.response ? error.response : error
    const status = response.status ? response.status : error.status

    if (status === 500 && attemptNumber < maxAttempts) {
      await new Promise(resolve => setTimeout(resolve, attemptDelayInSeconds * 1000))
      return pollMonitor(location, attemptNumber + 1)
    }

    throw response.data
  }
}

async function getProvider(providerSlug, attemptNumber = 1){
  const getProviderUri = new URI(config.apiBaseUrl)
  getProviderUri.segment('providers')
  getProviderUri.segment('v2')
  getProviderUri.segment('providers')
  getProviderUri.addSearch('slug', providerSlug)

  try{
    return await Vue.prototype.$http.get(getProviderUri.toString())
  }catch(error){
    const maxAttempts = config.getTokenMaxAttempts
    const attemptDelayInSeconds = config.getTokenAttemptDelayInSeconds

    const response = error.response ? error.response : error
    const status = response.status ? response.status : error.status

    if (status === 500 && attemptNumber < maxAttempts) {
      await new Promise(resolve => setTimeout(resolve, attemptDelayInSeconds * 1000))
      return getProvider(providerSlug, attemptNumber + 1)
    }

    throw error
  }
}

async function getSponsorTransactionCoverageTypeRequirements(providerSlug, sponsorSlug, transactionCoverageType, attemptNumber = 1) {
  const getSponsorTransactionCoverageTypeRequirementsUri = new URI(config.apiBaseUrl)
  getSponsorTransactionCoverageTypeRequirementsUri.segment('providers')
  getSponsorTransactionCoverageTypeRequirementsUri.segment('v1')
  getSponsorTransactionCoverageTypeRequirementsUri.segment('providers')
  getSponsorTransactionCoverageTypeRequirementsUri.segment(providerSlug)
  getSponsorTransactionCoverageTypeRequirementsUri.segment('sponsor')
  getSponsorTransactionCoverageTypeRequirementsUri.segment(sponsorSlug)
  getSponsorTransactionCoverageTypeRequirementsUri.segment('transaction-coverage-type')
  getSponsorTransactionCoverageTypeRequirementsUri.segment(transactionCoverageType)
  try{
    return await Vue.prototype.$http.get(getSponsorTransactionCoverageTypeRequirementsUri.toString())
  }catch(error){
    const maxAttempts = config.getTokenMaxAttempts
    const attemptDelayInSeconds = config.getTokenAttemptDelayInSeconds
    const response = error.response ? error.response : error
    const status = response.status ? response.status : error.status
    if (status === 500 && attemptNumber < maxAttempts) {
      await new Promise(resolve => setTimeout(resolve, attemptDelayInSeconds * 1000))
      return getSponsorTransactionCoverageTypeRequirements(providerSlug, sponsorSlug, transactionCoverageType, attemptNumber + 1)
    }
    throw error
  }
}

export {
  getSponsors,
  getSponsorProviders,
  getProvider,
  getSponsorTransactionCoverageTypeRequirements
}